module.exports = __webpack_public_path__ + "img/interior1.c3eae741.jpg";